import { render, staticRenderFns } from "./singleVideo.vue?vue&type=template&id=5752747d&scoped=true&"
import script from "./singleVideo.vue?vue&type=script&lang=js&"
export * from "./singleVideo.vue?vue&type=script&lang=js&"
import style0 from "./singleVideo.vue?vue&type=style&index=0&id=5752747d&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752747d",
  null
  
)

export default component.exports